import { defineMessages } from 'react-intl'
export default defineMessages({
  aboutHeader: { id: 'app.components.Footer.Headers.about' },
  helpHeader: { id: 'app.components.Footer.Headers.help' },
  contactHeader: { id: 'app.components.Footer.Headers.contact' },
  payHeader: { id: 'app.components.Footer.Headers.pay' },
  CashbackLink: { id: 'app.components.Footer.Links.CashbackLink' },
  BusinessLink: { id: 'app.components.Footer.Links.BusinessLink' },
  LynksVsEdfa3lyLink: { id: 'app.components.Footer.Links.lynksVs' },
  storesLink: { id: 'app.components.Footer.Links.ourFavStores' },
  prohibitedLink: { id: 'app.components.Footer.Links.prohibited' },
  prohibitedLinkKSA: { id: 'app.components.Footer.Links.prohibited.ksa' },
  termsLink: { id: 'app.components.Footer.Links.terms' },
  privacyPolicyLink: { id: 'app.components.Footer.Links.privacyPolicy' },
  faqLink: { id: 'app.components.Footer.Links.faq' },
  howLink: { id: 'app.components.Footer.Links.how' },
  contactLink: { id: 'app.components.Footer.Links.contact' },
  mailLink: { id: 'app.components.Footer.Links.mail' },
  fbLink: { id: 'app.components.Footer.Links.fb' },
  hotNo: { id: 'app.components.Footer.Links.no' },
  address: { id: 'app.components.Footer.Links.address' },
  copyRight: { id: 'app.components.Footer.copy' },
  exohubPowered:  { id: 'app.components.Footer.exohubPowered' },
  findTheLink: { id: 'app.components.Footer.findTheLink'}
})


// WEBPACK FOOTER //
// ./app/components/Footer/messages.js